module.exports = __webpack_public_path__ + "img/深圳市兆恒东北特钢.7d857add.jpg";